<template>

	<v-dialog		
	    v-model="visible"
		persistent
	    width="700"
		class="edit-dialog"
		ref="editDialog"
		eager
	>
	<transition>
		<v-card >
			
			<v-card-title class="text-subtitle-1 white--text info" color="darkseagreen" ref="editDialogTitle">
				{{title}}
			</v-card-title>
			<v-card-text class="pa-0 ma-0 edit-content">
				<div v-if="mode==1" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">父节点代码:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense 
							placeholder=""
							readonly
							:value="higher.code"
						>
						</v-text-field>						
					</div>
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">父节点编号:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="higher.id"
						>
						</v-text-field>						
					</div>
				</div>
				<div v-if="mode==1" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">父节点名称:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0  readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="higher.name"
						>
						</v-text-field>						
					</div>
				</div>
				
				<div v-if="mode==2" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">同级节点代码:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense 
							placeholder=""
							readonly
							:value="sameLevel.code"
						>
						</v-text-field>						
					</div>
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">同级节点编号:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="sameLevel.id"
						>
						</v-text-field>						
					</div>
				</div>
				<div v-if="mode==2" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">同级节点名称:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="sameLevel.name"
						>
						</v-text-field>						
					</div>
				</div>
				
				<div v-if="mode==3" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">原节点代码:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense 
							placeholder=""
							readonly
							:value="editOri.code"
						>
						</v-text-field>						
					</div>
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">原节点编号:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="editOri.id"
						>
						</v-text-field>						
					</div>
				</div>
				<div v-if="mode==3" class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">原节点名称:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							readonly
							:value="editOri.name"
						>
						</v-text-field>						
					</div>
				</div>
				
				<v-divider></v-divider>
				<!--编辑区 -->
				<div class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">代码:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0"
							:class="{'careful_input_item':mode==3}"
							outlined
							dense
							placeholder=""
							v-model="editing.code"							
						>
						</v-text-field>						
					</div>
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">名称:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0" 								
							outlined
							dense
							placeholder=""
							v-model="editing.name"
						>
						</v-text-field>						
					</div>
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">标题:</label>
						<v-text-field 
							class="form-item-value py-0 mr-0" 								
							outlined
							dense
							placeholder=""
							v-model="editing.title"
						>
						</v-text-field>						
					</div>
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">图标CSS类:</label>
						<v-text-field
							class="form-item-value py-0 mr-0" 								
							outlined
							dense
							placeholder=""
							v-model="editing.iconCssCls"
						>
						</v-text-field>					
					</div>
					<!-- span v-if="((null!=editing.iconCssCls)&&(editing.iconCssCls>0))" -->
					<v-btn 
						fab small outlined
						color="primary"
					>
						<v-icon
							color="primary"
							dark
						>
							{{editing.iconCssCls}}
						</v-icon>						
					</v-btn>
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">类型:</label>
						<v-select
                            class="form-item-value py-0 mr-0" 	
                            v-model="editing.type"
                            :items="menuTypes"						
                            label=""
                            hide-details											
                            flat
                            solo
                            outlined
                            dense						                            
                            item-text="typeName"
                            item-value="typeId"
                            full-width						
						>
						</v-select>					
					</div>
                    <div class="form-item form-item-width-1 pr-1 ma-0" v-show="editing.type==5">
						<label class="form-item-label py-0 mt-0 mr-0">按钮模式:</label>
						<v-select
                            class="form-item-value py-0 mr-0" 	
                            v-model="editing.buttonTypeId"
                            :items="buttonTypes"						
                            label=""
                            hide-details											
                            flat
                            solo
                            outlined
                            dense						
                            
                            item-text="typeName"
                            item-value="typeId"
                            full-width
                            						
						>
						</v-select>					
					</div>
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">排序号:</label>
						<v-text-field
							class="form-item-value py-0 mr-0" 								
							outlined
							dense
							placeholder=""
							v-model="editing.orderNum"
							type="number"
						>
						</v-text-field>						
					</div>
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">菜单模块:</label>
						<v-select
                            class="form-item-value py-0 mr-0" 	
                            v-model="editing.menuModule"
                            :items="menuModules"						
                            label=""
                            hide-details											
                            flat
                            solo
                            outlined
                            dense						
                            return-object
                            item-text="title"
                            item-value="id"
                            full-width
                            :disabled="isNotTopLevelMenu()"
						>
						</v-select>					
					</div>
				</div>
				
				<v-divider>界面组件</v-divider> 
				
				<div class="pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">模块号:</label>
						<v-text-field
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							v-model="editing.moduleFunctionComponent.moduleId"						
							type="number"
							readonly
						>
						</v-text-field>						
					</div>
					
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">模块名:</label>
						<v-text-field
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							v-model="editing.moduleFunctionComponent.moduleName"
							readonly=""
						>
						</v-text-field>						
					</div>
				</div>
				
				<div class="pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-1 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">功能编号:</label>
						<v-text-field
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							v-model="editing.moduleFunctionComponent.moduleFuncId"
							readonly
						>
						</v-text-field>						
					</div>
					
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">功能代码:</label>
						<v-text-field
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							v-model="editing.moduleFunctionComponent.moduleFuncCode"
							readonly=""
						>
						</v-text-field>						
					</div>
				</div>
				
				<div class="pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-3 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">功能名:</label>
						<v-text-field
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							v-model="editing.moduleFunctionComponent.moduleFuncName"							
							readonly
						>
						</v-text-field>						
					</div>
					
				</div>
				
				<div class="pt-1 py-1 ma-0 d-flex flex-row">
					<div class="form-item form-item-width-2 pr-1 ma-0">
						<label class="form-item-label py-0 mt-0 mr-0">类型:</label>
						<v-text-field
							class="form-item-value py-0 mr-0 readonly_input_item" 								
							outlined
							dense
							placeholder=""
							v-model="editing.moduleFunctionComponent.typeName"
							readonly
						>
						</v-text-field>						
					</div>
					
					<div class="form-item form-item-width-1 pr-1 ml-2 pl-2">
						<v-btn
							color="info"
							rounded
							@click="toSelectModuleFunctionComp"							
						>
							<span class="px-2"><v-icon>mdi-file-cancel-outline</v-icon></span>
							选择界面功能组件...
						</v-btn>					
					</div>
				</div> 
								
				<v-divider>附带功能项目</v-divider> 
				
				<div class="py-2 ma-0 pl-4">
					
					<v-btn
						color="info left-round"
						@click="toSelectMenuRelateModuleFunction"							
					>
						<span class="px-2"><v-icon>mdi-file-outline</v-icon></span>
						添加连带功能...
					</v-btn>
					<v-btn
						color="warning right-round"
						class ="ml-2"
						
						@click="toDeleteMenuRelateModuleFunction"							
					>
						<span class="px-2"><v-icon>mdi-note-remove-outline</v-icon></span>
						删除连带功能
					</v-btn>		
					
				</div>
				
				<div class="flex-grow-0 flex-shrink-0 pt-1 py-1 ma-0 pa-0"  style="position:relative;height:300px">
					<div style="position:absolute;top:0;bottom:0;left:0;right:0;" class="pa-0">
						<v-data-table :headers="headers" fixed-header :items="editing.menuRelateModuleFunctions" class="elevation-1 module-function-table pa-0"
						 disable-pagination hide-default-footer height="100%" width="100%" single-select show-select item-key="moduleFuncId"
						 v-model="selectedMenuRelateModuleFunctions">							
						</v-data-table>
					</div>
				</div>
								
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
			  <v-spacer></v-spacer>
			  <v-btn
				color="blue-grey"
				class="left-round"
				@click="setVisible(false)"
			  >
				<span class="px-2"><v-icon>mdi-file-cancel-outline</v-icon></span>
				取消
			  </v-btn>
			  <v-btn
				color="success"
				class="right-round"
				@click="handleSave"
			  >
				保存
				<span class="px-2"><v-icon>mdi-content-save-move-outline</v-icon></span>
			  </v-btn>
			</v-card-actions>
		</v-card>
	</transition>
		<module-function-select-dialog
			ref="moduleFunctionCompSelectDialog"
			:singleSelect='true'
			:condType='compModuleFunctionTypes'
			v-on:moduleFunctionSelected="moduleFunctionCompSelected"
			:resultCheck="moduleFunctionCompSelectCheck"
		>
		</module-function-select-dialog>
		
		<module-function-select-dialog
			ref="menuRelateModuleFunctionSelectDialog"
			:singleSelect='false'
			:condType='apiModuleFunctionTypes'
			v-on:moduleFunctionSelected="menuRelateModuleFunctionSelected"
			:resultCheck="menuRelateModuleFunctionSelectCheck"
		>
		</module-function-select-dialog>
	</v-dialog>
</template>

<script>
	import {default as MenuTypeApi} from "../../../../api/smp/sys/MenuTypeApi.js";
	import {default as ModuleFunctionApi} from "../../../../api/smp/sys/ModuleFunctionApi.js";
	import {default as MenuModuleApi} from "../../../../api/smp/sys/MenuModuleApi.js";
	import ModuleFunctionSelectDialog from "../module/ModuleFunctionSelectDialog.vue";
	import {default as AppConfig} from "../../../../config/app.js";
    import {default as MenuApi} from "../../../../api/smp/sys/MenuApi.js";
    import {default as ButtonTypeApi} from "../../../../api/smp/sys/ButtonTypeApi.js";
	import {default as DragSupport} from '../../../../util/drag.js';
	
	export default {
		name: 'EditMenuDialog',
		components: {
			"module-function-select-dialog":ModuleFunctionSelectDialog
		},
		data: () => ({
			headers: [				
				{
					text: '代码',
					value: 'moduleFuncCode',
					sortable: false,
					width: 200,
					divider: true
				},
				{
					text: '编号',
					align: 'start',
					sortable: false,
					value: 'moduleFuncId',
					width: 80,
					divider: true
				},
				{
					text: '名称',
					value: 'moduleFuncName',
					sortable: false,
					width: 200,
					divider: true
				},
				{
					text: '模块号',
					value: 'moduleId',
					sortable: false,
					width: 80,
					divider: true
				},
				{
					text: '模块名',
					value: 'moduleName',
					sortable: false,
					width: 200,
					divider: true
				},
				{
					text: '类型',
					value: 'typeName',
					sortable: false,
					width: 80,
					divider: true
				},
				{
					text: '方法',
					value: 'methodName',
					sortable: false,
					width: 100,
					divider: true
				},
				{
					text: '路径',
					value: 'path',
					sortable: false,
					width: 300,
					divider: true
				}
			
			],
			visible:false,
			mode:0, //1新增下级，2新增同级 3编辑
			higher:{},
			sameLevel:{},
			editOri:{},
			editing:{
				id:"",
				code:"",
				name:"",
				title:'',
				type:"",
				orderNum:"",
                iconCssCls:"",
                buttonTypeId:"",
				moduleFunctionComponent:{
					moduleId:'',
					moduleName:'',
					typeId:'',
					typeName:'',
					moduleFuncId:'',
					moduleFuncCode:'',
					moduleFuncName:'',
					
				},
				menuRelateModuleFunctions:[],
			},
            menuTypes:[],
            buttonTypes:[],
			menuModules:[],
			compModuleFunctionTypes:[3,5],
			apiModuleFunctionTypes:[1],
			//本界面上通过checkbox选中的function
			selectedMenuRelateModuleFunctions:[]
		}),
		methods:{
			toSelectModuleFunctionComp(){
				this.$refs.moduleFunctionCompSelectDialog.clear();
				this.$refs.moduleFunctionCompSelectDialog.setVisible(true);
			},
			toSelectMenuRelateModuleFunction(){
				this.$refs.menuRelateModuleFunctionSelectDialog.clear();
				this.$refs.menuRelateModuleFunctionSelectDialog.setVisible(true);
			},
			toDeleteMenuRelateModuleFunction(){
				let me = this;
				if((this.selectedMenuRelateModuleFunctions)&&(this.selectedMenuRelateModuleFunctions.length==1)){
					let moduleFunction = this.selectedMenuRelateModuleFunctions[0];
					let pos = -1;
					let idx=-1;
					for(idx=0;idx<me.editing.menuRelateModuleFunctions.length;++idx){
						if(me.editing.menuRelateModuleFunctions[idx].moduleFuncId==moduleFunction.moduleFuncId){
							pos = idx;
							break;
						}
					};
					
					if(pos!=-1){
						me.editing.menuRelateModuleFunctions.splice(pos,1);
					}
				}
			},
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			async  infoMsg(title,text){
				await this.$dialog.info({
					text: text,
					title: title
				});
			},
			async  confirmMsg(title,text){
				return await this.$dialog.confirm({
					text: text,
					title: title
				});
			},
			isNotTopLevelMenu(){
				if(this.mode==1){
					return true;
				}else if(this.mode==2){
					return (this.sameLevel.code.length>4);
				}else if(this.mode==3){
					return (this.editOri.code.length>4);
				}
				return false;
			},
			setVisible(v){
                this.visible=v;
                let dialogEl = this.$refs.editDialog.$refs.dialog;
                console.log(this.$refs.editDialogTitle);
				if(this.visible==true)
					DragSupport.bind(dialogEl,this.$refs.editDialogTitle);
				else
					DragSupport.unbind(dialogEl);
			},
			setMode(m){
				this.mode=m;
				this.clearInput();
			},
			setHigher(h){
				this.higher = h;
			},
			setSameLevel(sl){
				this.sameLevel = sl;
			},
			setEdit(e){
				this.editOri = e;
				this.editing.code=e.code;
				this.editing.name=e.name;
				this.editing.title=e.title;
				this.editing.id=e.id;
				this.editing.type=e.type;
				this.editing.orderNum=e.orderNum;
                this.editing.iconCssCls=e.iconCssCls;
                
                this.editing.buttonTypeId=e.buttonTypeId;
				
				this.editing.menuModule={
					id:e.menuModuleId
				};
				
				this.editing.moduleFunctionComponent={
					moduleId:e.moduleId,
					moduleName:e.moduleName,
					typeId:e.funcTypeId,
					typeName:e.funcTypeName,
					moduleFuncId:e.funcId,
					moduleFuncCode:e.funcCode,
					moduleFuncName:e.funcName,
				},
				this.editing.menuRelateModuleFunctions=[];
				this.loadRelateFunctions();
			},
			clearInput(){
				this.editing={
					id:"",
					code:"",
					name:"",
					type:{typeId:"",typeName:""},
					orderNum:0,
					title:"",
					iconCssCls:"",
					moduleFunctionComponent:{},
					menuRelateModuleFunctions:[],
				};
			},
			moduleFunctionCompSelected(selected){
				let me = this;
				let selectedComp = selected[0];
				me.editing.moduleFunctionComponent = selectedComp;
			},
			async moduleFunctionCompSelectCheck(selected){
				let me = this;
			   
				if((!selected)||(selected.length<1)){
					let notUsed = await me.errMsg("错误","还没有选择模块/功能");
					return false;
				}
				if(selected.length>1){
					let notUsed = await me.errMsg("错误","菜单组件只能对应一个选择模块/功能组件，请选择一个");
					return false;
				}
				let selected0 = selected[0];
				if(!((selected0.typeId==3)||(selected0.typeId==5))){
					let notUsed = await me.errMsg("错误","请选择一个界面功能组件");
					return false;
				}
			   
			   return true;
			},
			menuRelateModuleFunctionSelected(selected){
				let me = this;
				console.log("selected");
				console.log(selected);
				let found = false;
				selected.forEach( function(aSelectedModuleFunction){
					found = false;
					me.editing.menuRelateModuleFunctions.forEach(function(item){
						if(item.moduleFuncId==aSelectedModuleFunction.moduleFuncId)
							found = true;
					});
					if((found==false)&&(aSelectedModuleFunction.typeId==1)){
						me.editing.menuRelateModuleFunctions.push(aSelectedModuleFunction);
					}
				});
			},
			async menuRelateModuleFunctionSelectCheck(selected){
				let me = this;
				if((!selected)||(selected.length<1)){
					let notUsed = await me.errMsg("错误","还没有选择模块/功能");
					return false;
				}
				if(selected.length>30){
					let notUsed = await me.errMsg("错误","选择了太多的功能api了");
					return false;
				}
				
				let apiFounded = false;
				let notApiFounded = false;
				selected.forEach(function(item){
					if(item.typeId!=1){
						notApiFounded = true;
					}else{
						apiFounded = true;
					}
				});
				
				if(apiFounded==false){	
					let notUsed = await me.errMsg("错误","此处只能选择API功能组件，您还没有选择api功能");
					return false;
				}else if(notApiFounded==true){
					let confirmed = await me.confirmMsg("注意","此处只能选择API功能组件，选择确定并入选择api功能");
					console.log("prompt->:"+confirmed);
					return (confirmed==true);
				}else{
					return true;
				}
			},
			handleSave(){
				let me = this;
				if((!this.editing.code)||(this.editing.code.trim()=='')){
					me.errMsg('错误','还没有输入菜单代号');
					return;
				}
				if((!this.editing.name)||(this.editing.name.trim()=='')){
					me.errMsg('错误','还没有输入菜单名称');
					return;
				}
				if((!this.editing.title)||(this.editing.title.trim()=='')){
					me.errMsg('错误','还没有录入菜单标题');
					return;
				}
				if((!this.editing.orderNum)||(this.editing.orderNum.trim()=='')){
					me.errMsg('错误','还没有录入排序号');
					return;
				}
				if(isNaN(this.editing.orderNum)){
					me.errMsg('错误','排序号必须是数字');
					return;
				}
				if(!this.editing.type){
					me.errMsg('错误','还没有选择类型');
					return;
				}
				
				if(this.editing.type==1){
					if((!this.editing.moduleFunctionComponent)
					||(!this.editing.moduleFunctionComponent.moduleFuncId)
					||(this.editing.moduleFunctionComponent.moduleFuncId=='')){
						me.errMsg('错误','需要为菜单选择一个界面组件');
						return;
					}
				}
				
				let codeLength = this.editing.code.length;
				if(this.mode==1){
					let parentCodeLength = this.higher.code.length;
					if(codeLength-parentCodeLength != 1*AppConfig.MENU_CODE_LEVEL_LENGTH){
						me.errMsg('错误','菜单代码长度错误');
						return;
					}
					if(this.editing.code.substr(0,parentCodeLength)!=this.higher.code){
						me.errMsg('错误','菜单代码错误,前'+parentCodeLength+'位必须和上级代码保持一致');
						return;
					}
				}else if(this.mode==2){
					let sameLevelCodeLength = this.sameLevel.code.length;
					let parentCodeLength = sameLevelCodeLength-1*AppConfig.MENU_CODE_LEVEL_LENGTH;
					if(codeLength != sameLevelCodeLength){
						me.errMsg('错误','菜单代码长度和同级菜单长度不一致');
						return;
					}
					if(this.editing.code.substr(0,parentCodeLength)!=this.sameLevel.code.substr(0,parentCodeLength)){
						me.errMsg('错误','菜单代码错误,前'+parentCodeLength+'位必须和同级代码保持一致');
						return;
					}
					if(codeLength==1*AppConfig.MENU_CODE_LEVEL_LENGTH){
						if(!me.editing.menuModule){
							me.errMsg('错误','顶级菜单需要选择菜单模块');
							return;
						}
					}
				}else if(this.mode==3){
					let oriCodeLength = this.editOri.code.length;
					let parentCodeLength = oriCodeLength-1*AppConfig.MENU_CODE_LEVEL_LENGTH;
					if(codeLength != oriCodeLength){
						me.errMsg('错误','菜单代码长度原长度不一致');
						return;
					}
					if(this.editing.code.substr(0,parentCodeLength)!=this.editOri.code.substr(0,parentCodeLength)){
						me.errMsg('错误','菜单代码错误,前'+parentCodeLength+'位必须和原代码保持一致');
						return;
					}
					if(codeLength==1*AppConfig.MENU_CODE_LEVEL_LENGTH){
						if(!me.editing.menuModule){
							me.errMsg('错误','顶级菜单需要选择菜单模块');
							return;
						}
					}
				}
								
				let requestData={
					code:me.editing.code,
					name:me.editing.name,
					title:me.editing.title,
                    type:me.editing.type,
                    buttonTypeId:me.editing.buttonTypeId,
					orderNum:parseInt(me.editing.orderNum),
					iconCssCls:me.editing.iconCssCls,	
					relateModuleFunctions:[]
				};
				if(requestData.type==1 || requestData.type==3 || requestData.type==5){
					requestData.leafFlag=1;
				}else{
					requestData.leafFlag=0;
				}
				if(requestData.code.length==1*AppConfig.MENU_CODE_LEVEL_LENGTH){
					requestData.menuModuleId = me.editing.menuModule.id;
				}
				if(requestData.type==1){
					requestData.funcId=me.editing.moduleFunctionComponent.moduleFuncId;
				}
				
				if(me.mode==1){
					requestData.appId=me.higher.appId;
				}else if(me.mode==2){
					requestData.appId=me.sameLevel.appId;
				}else if(me.mode==3){
					requestData.appId=me.editOri.appId;
					requestData.id = me.editOri.id;
				}
				
				if(me.editing.menuRelateModuleFunctions){
					me.editing.menuRelateModuleFunctions.forEach(function(item){
						requestData.relateModuleFunctions.push({moduleFuncId:item.moduleFuncId});
					});
				}
				console.log("persist menu request:");
				console.log(requestData);
				
				//开始发送请求
				MenuApi.persistMenu(requestData).then(function(resp){
					console.log(resp);
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'保存菜单信息失败':msg;
						throw new Error(msg);
						return;
					}
					
					let menu = data.data.menu;
					console.log("persist menu finished");
					console.log(menu);
					me.infoMsg('成功','菜单数据已经保存');
					me.setVisible(false);
					if((me.mode==1) || (me.mode==2))
						me.$emit("menuAdded",menu);
					else if(me.mode==3)	
						me.$emit("menuUpdated",menu);
				}).catch(function(err){
					console.log(err.stack);
					console.log(err);
					me.errMsg('错误','保存菜单信息失败:'+err.message);
				});
			},
			loadMenuTypes(){
				let me = this;
				MenuTypeApi.queryMenuType().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取菜单类型信息失败':msg;
						throw new Error(msg);
						return;
					}

					let menuTypes = data.data.menuTypes;
					console.log("request menuTypes returned:");
					console.log(menuTypes);
					me.menuTypes = menuTypes
				}).catch(function(err){
					console.log(err);
					me.errMsg('错误','获取菜单类型信息失败:'+err.message);
				});
            },
            loadButtonTypes(){
                let me = this;
				ButtonTypeApi.queryAllButtonType().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取按钮类型信息失败':msg;
						throw new Error(msg);
						return;
					}

					let buttonTypes = data.data.buttonTypes;
					console.log("request buttonTypes returned:");
					console.log(buttonTypes);
					me.buttonTypes = buttonTypes
				}).catch(function(err){
					console.log(err);
					me.errMsg('错误','获取按钮类型信息失败:'+err.message);
				});
            },
			loadRelateFunctions(){
				let me = this;
				if(me.mode!=3)
					return;
				ModuleFunctionApi.queryMenuRelateFunction(me.editOri.id).then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取连带功能信息失败':msg;
						throw new Error(msg);
						return;
					}
				
					let moduleFunctions = data.data.moduleFunctions;
					console.log("request menuRelateFunction returned:");
					console.log(moduleFunctions);
					me.editing.menuRelateModuleFunctions = moduleFunctions
				}).catch(function(err){
					console.log(err);
					me.errMsg('错误','获取连带功能信息失败:'+err.message);
				});
			},
			loadMenuModules(){
				let me = this;				
				MenuModuleApi.queryAllMenuModules().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取菜单模块信息失败':msg;
						throw new Error(msg);
						return;
					}
				
					let menuModules = data.data.menuModules;
					console.log("request menuModules returned:");
					console.log(menuModules);
					me.menuModules = menuModules
				}).catch(function(err){
					console.log(err);
					me.errMsg('错误','获取菜单模块信息失败:'+err.message);
				});
			},
		},
		computed:{
			title(){
				if(this.mode==1)
					return "增加菜单/按钮(下级)";
				else if(this.mode==2)
					return "增加菜单/按钮(同级)";
				else if(this.mode==3)
					return "编辑菜单/按钮";
				else
					return "未知菜单/按钮操作";			
			}
		},
		mounted(){
			this.loadMenuTypes();	
            this.loadMenuModules();
            this.loadButtonTypes();	
		},
	}
</script>

<style scoped>
	.module-function-table {
		width: 100%;
		height: 100%;
		max-width: 100%;
		max-height: 100%;
	}
	.edit-dialog{
		border-radius: 4px;
	}
	.readonly_input_item{
		background-color:lightgray;
	}
	.careful_input_item{
		background-color:lightblue;
	}
	
	.edit-content{
		max-height: 550px;
		overflow-y: scroll;
	}
</style>
